import { jsx as c } from "react/jsx-runtime";
import { useRef as g, useMemo as R } from "react";
import { useAuth as v } from "@dcentralexpedientedigital/fe-shared/hooks/use-auth";
import { useOidcEvents as w } from "@dcentralexpedientedigital/fe-shared/hooks/use-oidc-events";
import { Realtime as k } from "ably";
import { AblyProvider as y, ChannelProvider as P } from "ably/react";
import { decodeToken as x } from "../utils/jwt.js";
const A = [
  "owner-wallets-changed",
  "owner-bonuses-changed",
  "owner-promotions-changed",
  "deposit-limits-changed",
  "kyc-results-changed",
  "dlst-items"
], T = ({
  tenantId: a,
  isLoggedIn: i,
  userId: d,
  channels: m = A,
  deriveOptions: u,
  children: p
}) => {
  var l;
  const { auth: s } = v(), n = ((l = s == null ? void 0 : s.user) == null ? void 0 : l.access_token) ?? null, t = g(null);
  w({
    onUserLoaded: () => {
      console.log("[RealtimeProvider] User has loaded"), t.current && (t.current(), t.current = null);
    }
  });
  const h = R(() => (console.log("[RealtimeProvider] Recreating client isLoggedIn:", i), new k({
    async authCallback(r, o) {
      if (n || await new Promise((e) => {
        t.current = e;
      }), console.log("[RealtimeProvider] Attempting token authentication..."), !n)
        return o(
          { statusCode: 403, message: "No token", code: 403, name: "Unauthorized" },
          null
        );
      try {
        const e = x(n);
        o(null, {
          capability: "*",
          token: e["x-ably-token"],
          expires: e.exp,
          issued: e.iat
        });
      } catch (e) {
        o(
          {
            code: 500,
            message: `Error when decoding JWT: ${e}`,
            name: "UNKNOWN_ERROR",
            statusCode: 500
          },
          null
        );
      }
    }
  })), [i, n]), f = m.map(
    (r) => `${a ?? ""}:profiles:${d ?? ""}:${r}`
  );
  return /* @__PURE__ */ c(y, { client: h, children: f.reduce(
    (r, o) => /* @__PURE__ */ c(
      P,
      {
        channelName: o,
        deriveOptions: u,
        children: r
      },
      o
    ),
    p
  ) });
};
export {
  T as RealtimeApiProvider
};
